export const isDateValid = (
  stringDate: string | undefined,
  minDate: Date | undefined,
  invalidDates: Date[] | undefined,
): boolean => {
  if (!stringDate) return false;
  const stringDateCorrectForm = stringDate.split('.').reverse().join('-');

  if (Number.isNaN(Date.parse(stringDateCorrectForm))) return false;
  const date = new Date(stringDateCorrectForm);

  return (
    (!minDate || date >= minDate) && (!invalidDates || !invalidDates.find(item => item.getTime() === date.getTime()))
  );
};
